.container {
  padding: 16px;
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.header h2 {
  margin: 0;
  font-size: 1.2rem;
}

.memberList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.memberCard {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: var(--tg-theme-secondary-bg-color, #f0f0f0);
  border-radius: 12px;
}

.memberInfo {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.memberRole {
  font-size: 0.8rem;
  opacity: 0.6;
}

.memberName {
  font-weight: 500;
}

.memberSign {
  font-size: 0.85rem;
  opacity: 0.7;
}

.removeBtn {
  background: none;
  border: none;
  color: var(--tg-theme-destructive-text-color, #ff3b30);
  cursor: pointer;
  padding: 4px 8px;
  font-size: 0.85rem;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 12px;
  font-size: 0.95rem;
  cursor: pointer;
  text-align: center;
}

.btnPrimary {
  background: var(--tg-theme-button-color, #3390ec);
  color: var(--tg-theme-button-text-color, #fff);
}

.btnSecondary {
  background: var(--tg-theme-secondary-bg-color, #f0f0f0);
  color: var(--tg-theme-text-color, #000);
}

.btnDanger {
  background: none;
  color: var(--tg-theme-destructive-text-color, #ff3b30);
}

.forecastStatus {
  text-align: center;
  margin: 12px 0;
  font-size: 0.9rem;
  opacity: 0.7;
}

.hint {
  text-align: center;
  margin: 12px 0;
  font-size: 0.85rem;
  opacity: 0.6;
}

.createForm {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.input {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--tg-theme-hint-color, #ccc);
  border-radius: 12px;
  font-size: 1rem;
  background: var(--tg-theme-secondary-bg-color, #f0f0f0);
  color: var(--tg-theme-text-color, #000);
  box-sizing: border-box;
}

.roleGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 8px;
}

.roleBtn {
  padding: 12px;
  border: 1px solid var(--tg-theme-hint-color, #ccc);
  border-radius: 12px;
  background: var(--tg-theme-secondary-bg-color, #f0f0f0);
  color: var(--tg-theme-text-color, #000);
  cursor: pointer;
  font-size: 0.9rem;
  text-align: center;
}

.roleBtn:active {
  opacity: 0.7;
}

.chartList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.chartBtn {
  padding: 12px;
  border: 1px solid var(--tg-theme-hint-color, #ccc);
  border-radius: 12px;
  background: var(--tg-theme-secondary-bg-color, #f0f0f0);
  color: var(--tg-theme-text-color, #000);
  cursor: pointer;
  text-align: left;
  font-size: 0.9rem;
}

.forecastText {
  padding: 16px;
  background: var(--tg-theme-secondary-bg-color, #f0f0f0);
  border-radius: 12px;
  margin: 12px 0;
  line-height: 1.5;
  white-space: pre-wrap;
}

.loading {
  text-align: center;
  padding: 24px;
  opacity: 0.6;
}
